<template>
  <div class="info-up-box">
    <div class="text1 fw600 mb30 flex flex-between">
      <div>
        {{ showIndex === 1 ? "报名信息" : "资料上传" }}
      </div>
      <div @click="goback">
        <img
          style="width: 30px; height: 30px; cursor: pointer"
          src="~@/assets/images/img59.png"
          alt=""
          title="返回"
        />
      </div>
    </div>
    <step-view :showIndex="showIndex"></step-view>
    <div v-if="showIndex === 1">
      <step1
        @goStep="goStep"
        :editInfoStep1="editInfoStep1"
        :lockFromEnroll="lockFromEnroll"
        ref="step1"
      ></step1>
    </div>
    <div v-if="showIndex === 2">
      <step2
        :loadList="loadList1"
        :oldApplyFiles1="oldApplyFiles1"
        :imageUrl="imageUrl"
        @downStep="downStep"
        @upStep="upStep"
        @deleteFile="deleteFile"
        @upDataFile="upDataFile"
        @submit="submit"
      ></step2>
    </div>
  </div>
</template>

<script>
import stepView from "./stepView.vue";
import step1 from "./step1.vue";
import step2 from "./step2.vue";
import { lxApplySaveOrUpdate, deleteFile } from "../../api/index";
import { pieviewURL } from "../../utils/request";
export default {
  name: "",
  components: { stepView, step1, step2 },
  props: {
    editInfo: { type: Object, default: null },
    fromEnrollParams: { type: Object, default: null },
  },
  data() {
    return {
      showIndex: 1,
      lockFromEnroll: false,
      step1: null,
      step2: {},
      step3: {},
      oldApplyFiles1: [],
      oldApplyFiles2: [],
      spinning: false,
      loadList1: [
        {
          title: "教学视频",
          id: 1,
          remarks: "注：请上传MP4格式的文件，文件大小不超过1000M,视频时长10-15分钟,仅能上传一个文件。",
          accept: ".mp4",
          icon: require("../../assets/images/img24.png"),
          fileList: [],
          oldFileList: [],
          loading: false,
          loadings: false,
          uploadPercent: 0
        },
        // {
        //   title: "数字化典型小案例",
        //   id: 9,
        //   remarks: "注：请上传pdf/docx格式的文件，文件大小不超过100M,可上传两个文件。",
        //   accept: ".pdf,.docx",
        //   icon: require("../../assets/images/img24.png"),
        //   fileList: [],
        //   oldFileList: [],
        //   loading: false,
        // },
        {
          title: "教学设计",
          id: 2,
          remarks: "注：请上传pdf/docx格式的文件,仅能上传一个文件。",  
          accept: ".pdf,.docx",
          icon: require("../../assets/images/img24.png"),
          fileList: [],
          oldFileList: [],
          loading: false,
          uploadPercent: 0
        },
         {
          title: "微课逐字稿",
          id: 3,
          remarks: "注：请上传pdf格式的文件,仅能上传一个文件。",  
          accept: ".pdf",
          icon: require("../../assets/images/img24.png"),
          fileList: [],
          oldFileList: [],
          loading: false,
          uploadPercent: 0
        },
        {
          title: "微课课件",
          id: 7,
          remarks: "注：请上传pdf格式的文件，仅能上传一个文件。",
          accept: ".pdf",
          icon: require("../../assets/images/img24.png"),
          fileList: [],
          oldFileList: [],
          loading: false,
          uploadPercent: 0
        },
        {
          title: "参赛作品信息表",
          id: 8,
          remarks: "注：请上传pdf格式的文件，仅能上传一个文件。",
          accept: ".pdf",
          icon: require("../../assets/images/img24.png"),
          fileList: [],
          oldFileList: [],
          loading: false,
          uploadPercent: 0
        },
        {
          title: "参赛作品推荐表",
          id: 6,
          remarks: "注：请上传pdf格式的文件,仅能上传一个文件。",
          accept: ".pdf",
          icon: require("../../assets/images/img24.png"),
          fileList: [],
          oldFileList: [],
          loading: false,
          uploadPercent: 0
        },
        // {
        //   title: "佐证材料",
        //   id:3,
        //   remarks: "注：请上传pdf/docx格式的文件，文件大小不超过100M",
        //   accept: ".pdf,.docx,.xls,.xlsx",
        //   icon: require("../../assets/images/img24.png"),
        //   fileList: [],
        //   oldFileList: [],
        //   loading: false,
        // },
      ],
      loadList2: [],
      editInfoStep1: {},
      id: null,
      imageUrl:'',
    };
  },
  computed: {},
  watch: {
    fromEnrollParams: {
      immediate: true,
      handler() {
        if (this.editInfo === null) {
          this.applyFromEnrollParams();
        }
      },
    },
  },
  created() {},
  destroyed() {
    window.sessionStorage.removeItem(`step${this.$store.state.user.id}`);
  },
  mounted() {
    if (this.editInfo !== null) {
      this.id = this.editInfo.id;
      this.editInfoStep1 = this.editInfo;
      this.$nextTick(() => {
        if (this.$refs.step1) {
          this.$refs.step1.applyEnrollData(this.editInfo);
        }
      });
      this.imageUrl= this.editInfo.name;
      for (let i = 0; i < this.loadList1.length; i++) {
        this.editInfo.applyFiles.map((item1) => {
          if (this.loadList1[i].id == item1.fileType) {
            let newItem = {};
            let newApplyFiles = {};
            newApplyFiles.filePath = item1.filePath;
            newApplyFiles.fileType = item1.fileType;
            newItem.uid = item1.id;
            //  item1.filePath.slice()
            let newName = item1.filePath.slice(
              item1.filePath.lastIndexOf("/") + 1
            );
            let firstname = newName.slice(0, newName.lastIndexOf("_"));
            let lastname = newName.slice(newName.lastIndexOf("."));
            newItem.name = firstname + lastname;
            newItem.name1 = newName;
            newItem.fileType = item1.fileType;
            newItem.url = pieviewURL + newName;
            this.loadList1[i].fileList.push(newItem);
            this.oldApplyFiles1.push(newApplyFiles);
          }
        });
      }
    }
    this.applyFromEnrollParams();
  },
  methods: {
    applyFromEnrollParams() {
      const p =
        this.fromEnrollParams ||
        (this.$route &&
        this.$route.params &&
        this.$route.params.fromEnroll
          ? this.$route.params
          : null);
      if (!p || !p.fromEnroll || this.editInfo !== null) {
        return;
      }
      sessionStorage.removeItem(`step${this.$store.state.user.id}`);
      this.lockFromEnroll = true;
      const levelType = p.levelType;
      this.editInfoStep1 = {
        zpname: p.zpname,
        principals: p.principals,
        levelType:
          levelType !== undefined && levelType !== null && levelType !== ''
            ? Number(levelType)
            : null,
        teamType: p.teamType,
        teams: p.teams,
        suggestion: p.suggestion,
        enrollId: p.enrollId,
      };
      this.$nextTick(() => {
        if (this.$refs.step1) {
          this.$refs.step1.applyEnrollData(this.editInfoStep1);
        }
      });
    },
  	goback(){
  		this.$router.push({ name: 'alApply' }); sessionStorage.removeItem('qbsj');
  	},
    stepJump() {
    },
    goStep(item) {
      this.showIndex = 2;
      this.step1 = item;
    },
    uploadInfo(info) {
      this.loadList1 = info;
    },
    //上传文件更新
    upDataFile(fileItem, index, type) {
      if (type === 1) {
        let newItem = {};
        newItem.fileType = fileItem.fileType;
        let newName = fileItem.filePath.slice(
          fileItem.filePath.lastIndexOf("/") + 1
        );
        let firstname = newName.slice(0, newName.lastIndexOf("_"));
        let lastname = newName.slice(newName.lastIndexOf("."));
        newItem.name = firstname + lastname;
        newItem.name1 = newName;
        // newItem.url = pieviewURL + fileItem.filePath.slice(8);
        newItem.url = pieviewURL + newName;
        newItem.uid = fileItem.uid;
        this.loadList1[index].fileList.push(newItem);
      } else {
        let newItem = {};
        newItem.fileType = fileItem.fileType;
        let newName = fileItem.filePath.slice(
          fileItem.filePath.lastIndexOf("/") + 1
        );
        let firstname = newName.slice(0, newName.lastIndexOf("_"));
        let lastname = newName.slice(newName.lastIndexOf("."));
        newItem.name = firstname + lastname;
        newItem.name1 = newName;
        newItem.url = pieviewURL + newName;
        newItem.uid = fileItem.uid;
        this.loadList2[index].fileList.push(newItem);
      }
    },
    upStep(stepTwoList2, stepTwoList3,imageUrl) {
      this.showIndex = 1;
      this.step2 = stepTwoList3;
      this.oldApplyFiles1 = stepTwoList3;
      this.loadList1 = stepTwoList2;
      this.imageUrl=imageUrl;
    },
    deleteFile(file) {
      deleteFile({
        filePath: `linxuan/${file.name1}`,
      }).then((res) => {
        if (res.code === 200) {
          this.$message.success(res.message);
        }
      });
      this.oldApplyFiles1 = this.oldApplyFiles1.filter((item) => {
        if (item.filePath.indexOf(file.name1) === -1) {
          return item;
        }
      });
    },
    downStep(stepTwoList, stepTwoList2) {
      this.showIndex = 3;
      this.step2 = stepTwoList2;
      this.oldApplyFiles1 = stepTwoList2;
      this.loadList1 = stepTwoList;
    },
    submit(List, applyFiles2,num,imageUrl) {
      let data = {};
      this.spinning = true;
			let applyFiles =applyFiles2;
      // data.major1 = this.step1.major1;
      // data.major2 = this.step1.major2;
      // data.major3 = this.step1.major3;
      data.zpname = this.step1.zpname;
      data.applyFiles = applyFiles;
      // data.name = this.step1.name;
      // data.phone = this.step1.phone;
      data.principals = this.step1.principals;
      data.suggestion = this.step1.suggestion;
      data.schoolName = this.step1.schoolName;
      data.teams = this.step1.teams;
      data.levelType = this.step1.levelType;
      data.teamType = this.step1.teamType;
      data.name=imageUrl;
      // data.levelType = this.step1.levelType;
      let routerPath = "";
      if(this.$route.name === "alApplyDataUpload"){
      	 data.applyType = 4;
      	 routerPath = "alApply";
      }else if(this.$route.name === "xalDataUpload"){
        data.applyType = 1;
        routerPath = "xal";
      }
      if (this.id !== null) {
        data.id = this.id;
      }
      // ===== 旧逻辑（保留备用）：qbsj 为字符串 "null" 时 JSON.parse 得到 null，读 .id 会直接报错 =====
      // if(sessionStorage.getItem('qbsj')!=undefined){
      // 	 data.id =JSON.parse(sessionStorage.getItem('qbsj')).id;
      // }
      const qbsjRaw = sessionStorage.getItem("qbsj");
      if (qbsjRaw && qbsjRaw !== "null" && qbsjRaw !== "undefined") {
        try {
          const qbsjInfo = JSON.parse(qbsjRaw);
          if (qbsjInfo && qbsjInfo.id) data.id = qbsjInfo.id;
        } catch (e) {
          /* 缓存异常时忽略，按新增提交 */
        }
      }
      data.subState=num;
      // draw-role 无提交权限：编辑已有记录时沿用原提交状态，避免把分社已提交的记录降级为草稿
      if (
        this.$store.state.role === 'draw-role' &&
        this.editInfo &&
        this.editInfo.subState !== undefined &&
        this.editInfo.subState !== null &&
        this.editInfo.subState !== ''
      ) {
        data.subState = this.editInfo.subState;
      }
      this.addLxApplySaveOrUpdate(data, routerPath);
    },
    addLxApplySaveOrUpdate(data, routerPath) {
      lxApplySaveOrUpdate(data).then((res) => {
        if (res.code === 200) {
          this.$message.success(res.message);
          this.spinning = false;
          this.$router.push({ name: routerPath });
          sessionStorage.removeItem('qbsj');
          window.sessionStorage.removeItem(`step${this.$store.state.user.id}`);
        } else {
          this.$message.error(res.message);
          this.spinning = false;
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.info-up-box {
  width: 100%;
  height: 100%;
  // max-height: 635px;
  overflow-y: auto;
  padding: 15px 30px;
  background: #ffffff;
  border-radius: 10px;
}
.text1 {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
}
.text2 {
  font-size: 13px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
  margin-top: 14px;
  margin-bottom: 15px;
}
.mb30 {
  margin-bottom: 20px;
}
.fw600 {
  font-weight: 600;
}
.img-box {
  width: 50px;
  height: 50px;
  cursor: pointer;
  margin-bottom: 16px;
}
.img-box-2 {
  width: 19px;
  height: 19px;
  margin-right: 10px;
}
.img-box-3 {
  width: 241px;
  height: 203px;
  margin: 50px auto;
}
.img-box-4 {
  width: 12px;
  height: 12px;
  margin-right: 10px;
  margin-bottom: 5px;
}
.step-box {
  padding-bottom: 10px;
}
.submit-btn {
  width: 116px;
  height: 40px;
  margin: 0 auto;
  line-height: 38px;
  text-align: center;
  background: #c73630;
  border-radius: 10px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  cursor: pointer;
}
</style>
